import { FilterMatchMode } from "primereact/api";
import { PagingConstants } from "./PagingConstants";

export const INITIAL_LAZY_STATE = {
  first: 0,
  rows: PagingConstants.INITIAL_ROW_AMOUNT,
  page: 1,
  sortField: "time",
  sortOrder: -1,
  multiSortMeta: [{ field: "time", order: -1 }],
  filters: {
    "dataValue.OverallRAGStatus": {
      value: null,
      matchMode: FilterMatchMode.EQUALS,
    },
    time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    substationDisplayName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  },
};
